import {Routes} from '@angular/router';
import {DynamicFormComponent} from '../forms/boundary/dynamic-form/dynamic-form.component';
import {LoginCallback} from '../authentication/login-callback/login-callback';
import {AuthGuard} from '../authentication/auth-guard-guard';
import {UserProfile} from '../authentication/user-profile/user-profile';
import {HomePage} from '../pages/home-page/home-page';
import {AdminLayout} from '../admin/boundary/admin-layout/admin-layout';
import {FormList} from '../admin/boundary/form-list/form-list';
import {FormEditor} from '../admin/boundary/form-editor/form-editor';
import {ForwardingDashboard} from '../admin/boundary/forwarding-dashboard/forwarding-dashboard';
import {ForwardingFormConfig} from '../admin/boundary/forwarding-form-config/forwarding-form-config';

export const routes: Routes = [
  {path: '', component: HomePage},
  {path: 'forms/submit/:form', component: DynamicFormComponent},
  {path: 'callback', component: LoginCallback},
  {path: 'user/me', component: UserProfile, canActivate: [AuthGuard], data: {}},
  {
    path: 'admin',
    component: AdminLayout,
    canActivate: [AuthGuard],
    data: {roles: ['insurance_company', 'form-manager']},
    children: [
      {path: '', redirectTo: 'forms', pathMatch: 'full'},
      {path: 'forms', component: FormList},
      {path: 'forms/new', component: FormEditor},
      {path: 'forms/edit/:formId/:version', component: FormEditor},
      {path: 'forwarding', component: ForwardingDashboard},
      {path: 'forwarding/forms/:formId/versions/:version', component: ForwardingFormConfig}
    ]
  }
];
